import { render, staticRenderFns } from "./CompanyInviteCard.vue?vue&type=template&id=52dbc29e&"
import script from "./CompanyInviteCard.vue?vue&type=script&lang=js&"
export * from "./CompanyInviteCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInviteCard.vue?vue&type=style&index=0&id=52dbc29e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports